import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslatedChecklist } from '@modeso/aumico-lib-annualreport-fe';
import {
    IAumMenuItemPerRow,
    IAumMenuOptions,
    ITableDelegateWithRowActions,
    ITableOptions,
    SearchMode,
} from '@modeso/aumico-lib-core-fe';
import { I18NextService } from 'angular-i18next';
import { BehaviorSubject } from 'rxjs';

import { ChecklistActions } from '../../enums/checklist-actions.enum';

@Component({
    selector: 'checklist-table',
    templateUrl: './checklist-table.component.html',
    styleUrls: ['./checklist-table.component.scss'],
})
export class ChecklistTableComponent implements OnInit, ITableDelegateWithRowActions {
    @Input() checklists: TranslatedChecklist[];
    @Input() filterSubject: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    @Output() onEditChecklist = new EventEmitter<TranslatedChecklist>();
    @Output() onCopyChecklist = new EventEmitter<TranslatedChecklist>();
    @Output() onDeleteChecklist = new EventEmitter<string[]>();
    options: ITableOptions;

    constructor(
        private readonly i18n: I18NextService,
        private readonly domSanitizer: DomSanitizer,
        private readonly matIconRegistry: MatIconRegistry,
    ) {
        this.addSvgIcon('aumico-edit-checklist-icon');
        this.addSvgIcon('aumico-copy-checklist-icon');

        this.options = {
            columns: [
                {
                    name: 'select',
                },
                {
                    name: this.i18n.t('aumico_checklist_management_table_checklist_name') as string,
                    type: 'text',
                    property: 'name',
                    flex: 10,
                    excludedFromSearch: false,
                    searchMode: SearchMode.START_WITH,
                },
                {
                    name: this.i18n.t('aumico_checklist_management_table_checklist_created_at') as string,
                    type: 'date',
                    property: 'createdAt',
                    flex: 10,
                    excludedFromSearch: true,
                },
                {
                    name: this.i18n.t('aumico_checklist_management_table_checklist_last_change') as string,
                    type: 'date',
                    property: 'updatedAt',
                    flex: 10,
                    excludedFromSearch: true,
                },
                {
                    name: this.i18n.t('aumico_checklist_management_table_checklist_modified_by') as string,
                    type: 'text',
                    property: 'updatedBy',
                    flex: 10,
                    excludedFromSearch: true,
                },
                {
                    name: 'settings',
                    flex: 10,
                },
            ],
            rowClickAction: {
                property: 'id',
                action: 'edit',
            },

            menu: this.getMenuOptions(),
        };
    }

    onMenuItemPerRowClick(action: string, row: any, item?: IAumMenuItemPerRow, event?: Event): void {
        if (action == ChecklistActions.EDIT) {
            this.onEditChecklist.emit(row);
        } else if (action == ChecklistActions.COPY) {
            this.onCopyChecklist.emit(row);
        }
    }
    onMenuClicked?(selectedRowsNum: Number): void {}

    onRowButtonClicked(id: string, action?: string): void {}

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>): void {
        const ids = selectedRows.selected.map((row) => row.id);
        selectedRows.clear();

        if (action == ChecklistActions.DELETE) {
            this.onDeleteChecklist.emit(ids);
        }
    }

    onSingleRowSelection?(id: string, checked: boolean): void {}

    ngOnInit(): void {}

    private getMenuOptions(): IAumMenuOptions {
        const menuOptions: IAumMenuOptions = {
            items: [
                {
                    caption: this.i18n.t('aumico_button_delete') as string,
                    action: ChecklistActions.DELETE,
                },
            ],
            actionButtons: [
                {
                    caption: this.i18n.t('aumico_button_copy') as string,
                    action: ChecklistActions.COPY,
                    icon: 'aumico-copy-checklist-icon',
                },
                {
                    caption: this.i18n.t('aumico_button_edit') as string,
                    action: ChecklistActions.EDIT,
                    icon: 'aumico-edit-checklist-icon',
                },
            ],
        };
        return menuOptions;
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
